

import BasicGadget from '@/components/gadgets/BasicGadget.vue';
import BasicGadgetV3 from '@/components/gadgets/EditerBasicGadgetV3.vue';
import SampleGadget from '@/components/gadgets/SampleGadget.vue';
import SampleGadgetV3 from '@/components/gadgets/SampleGadgetV3.vue';
import CSVDLGadget from '@/components/gadgets/CSVDLGadget.vue';
import CSVDLGadgetV3 from '@/components/gadgets/CSVDLGadgetV3.vue';

export default {
  BasicGadget,
  BasicGadgetV3,
  SampleGadget,
  SampleGadgetV3,
  CSVDLGadget,
  CSVDLGadgetV3,
};
